module.exports = __webpack_public_path__ + "img/UM.eadfb4ed.svg";